import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const advanceDeductionService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/advance-deduction/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching advance-deduction list", error);
            throw error;
        }
    },

    async findById(studentId: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/advance-deduction/findById/${studentId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById advance-deduction", error);
            throw error;
        }
    },

    async save(item: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/advance-deduction/save`,
                item
            );
            return response.data;
        } catch (error) {
            console.error("Error save advance-deduction", error);
            throw error;
        }
    },

    async deleteById(id: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/advance-deduction/deleteById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById advance-deduction", error);
            throw error;
        }
    },
    async deleteByIds(ids: string[]): Promise<any> {
        try {
            const response = await apiClient.post<any>(`${BASE_URL}/api/v1/advance-deduction/deleteByIds`, ids);
            return response.data;
        } catch (error) {
            console.error("Error deleteByIds advance-deduction", error);
            throw error;
        }
    },
    async deleteAllByYear(trancheYear: number, trancheNumber: number, universityId: number): Promise<any> {
        console.log('universityId', universityId)
        try {
            const queryParams = universityId > 0? `universityId=${universityId}` : '';
            const response =  await apiClient.delete<any>(`${BASE_URL}/api/v1/advance-deduction/deleteAll/${trancheYear}/${trancheNumber}?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteByIds advance-deduction", error);
            throw error;
        }
    },
    async uploadStudentsCsv(formData: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/advance-deduction/upload-students-csv`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error save advance-deduction", error);
            throw error;
        }
    },
}

export default advanceDeductionService;
